import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const streamPostCardContainer = style({
  padding: `${space.s4}px ${space.s16}px ${space.s12}px`,
});

export const streamPostCardFooter = style([
  {
    paddingTop: 0,
    paddingBottom: space.s24,
    justifyContent: 'space-between',
    borderTop: 'none',
    flexWrap: 'wrap',
    display: 'flex',
    flexDirection: 'row',
  },
]);

export const streamPostCardLabels = style(
  responsiveStyle({
    desktop: { paddingLeft: 0 },
  }),
);

export const streamPostCardActions = style({
  borderRight: 'none',
});
